import environment from '../../../config'

export const loadNpsScript = (): Promise<void> =>
  new Promise<void>((resolve, reject) => {
    const element = document.createElement('script')

    const { src, productId, verbose } = environment.nps

    element.src = src
    element.type = 'text/javascript'
    element.async = true

    element.setAttribute('productId', productId)
    element.setAttribute('auth', 'ID_TOKEN')
    element.setAttribute('storage', 'local')
    element.setAttribute('enableConsoleLog', String(verbose))

    element.onload = () => {
      if (environment.debugEnabled) console.log('[NPS] Script loaded successfully.')
      resolve()
    }

    element.onerror = (err) => {
      document.head.removeChild(element)
      reject(
        err instanceof Event
          ? `[NPS] Could not load script at '${(err.target as HTMLScriptElement).src}'.`
          : err,
      )
    }

    document.head.appendChild(element)
  })
